import React, { Component } from "react";
import Description from "@/modules/Description";
import CardListWithTitle from "@/modules/CardListWithTitle";
import Banner from "@tc/components/Banner";
import Eligibility from "@tc/components/Eligibility";
import Speaker from "@tc/components/Speaker";
import Sponsor from "@tc/components/Sponsor";
import Program from "@tc/components/Program";
import Navbar from "@tc/components/Navbar";
import Faq from "@/modules/Faq";
import Contact from "@/modules/Contact";
import Footer from "@tc/components/Footer";
import Application from "@/modules/Application";
import MessageEn from './messageEn'
import "./App.scss";

class App extends Component {
  constructor(props) {
    super(props);
    this.url = `${window.location.origin}/techcareerday`;
    this.imageURL = `${window.location.origin}/techcareerday/images/seo-cover.jpg`;
    this.state = {
      message: MessageEn(),
    }
  }

  getHelmetScript() {
    const message = this.state.message.application;

    return [{
      type: "application/ld+json",
      innerHTML: JSON.stringify({
        "@context": "http://schema.org",
        "@type": "Event",
        name: "Tech@Shopee Career Day 2021",
        description: message.desc,
        image: this.imageURL,
        startDate: message.startDate,
        endDate: message.endDate,
        url: this.url,
        audience: {
          audienceType: "Students and Professionals passionate about Data across the region!"
        },
        location: {
          "@type": "Place",
          name: "Shopee Singapore",
          address: "Online",
        }
      })
    }]
  }

  render() {
    let Message = this.state.message;
    const script = this.getHelmetScript();
    return (
      <div className="App">
        <Application
          message={Message.application}
          url={this.url}
          imageURL={this.imageURL}
          script={script}
          viewport={true}
        />
        <Navbar message={Message.navbar} />
        <Banner message={Message.banner} />
        <Description message={Message.about} id="about"></Description>
        <CardListWithTitle id="expect" message={Message.expect} />
        <Sponsor message={Message.sponsor} />
        <Eligibility message={Message.eligibility} />
        <Program message={Message.program} />
        <div id="sessions">
          <CardListWithTitle message={Message.sessions} />
        </div>
        <Speaker message={Message.speaker}/>
        <Faq message={Message.faq} />
        <Contact message={Message.contact} />
        <Footer message={Message.footer} />
      </div>
    );
  }
}

export default App;
